"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var slider_1 = __importDefault(require("../helpers/slider"));
var FeaturedCollection = /** @class */ (function () {
    function FeaturedCollection() {
        this.config = {
            htmlElement: null,
            slider: {
                htmlElement: null
            },
            selectors: {
                main: '[data-featured-collection]',
                slider: '[data-featured-collection-slider]',
                grid: '[data-featured-collection-grid]'
            }
        };
    }
    FeaturedCollection.prototype.init = function () {
        var _this = this;
        document.querySelectorAll(this.config.selectors.main).forEach(function (htmlElement) {
            _this.load(htmlElement);
        });
    };
    FeaturedCollection.prototype.load = function (htmlElement) {
        this.config.htmlElement = htmlElement;
        this.config.slider.htmlElement = this.config.htmlElement.querySelector(this.config.selectors.slider);
        if (this.config.slider.htmlElement)
            this.slider();
    };
    FeaturedCollection.prototype.slider = function () {
        return slider_1.default.init(this.config.slider.htmlElement, {
            // @ts-ignore comment
            prevButton: this.config.htmlElement.querySelector('[data-slider-prev-btn]'),
            nextButton: this.config.htmlElement.querySelector('[data-slider-next-btn]')
        });
    };
    return FeaturedCollection;
}());
exports.default = new FeaturedCollection();
